import React from 'react'
import styles from './Btn.module.css';

const Btn = ({text, onClick}) => <button onClick={onClick} className={styles.btn}>{text}</button>

export default Btn